import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';
import { ConfigService } from '../../config/config.service';
import { SessionService } from './session.service';
import { httpExtensionService } from './httpextension.service';
@Injectable()
export class OrdersService {

    constructor(private http: httpExtensionService, private config: ConfigService, private sessionService: SessionService) { }

    serialize = function(obj, prefix) {
        var str = [], p;
        for(p in obj) {
            if (obj.hasOwnProperty(p)) {
                var k = prefix ? prefix : p, v = obj[p];
                str.push((v !== null && typeof v === "object") ?
                this.serialize(v, k) :
                encodeURIComponent(k) + "=" + encodeURIComponent(v));
            }
        }
        return str.join("&");
     }

    getAllOrders(_body) {
        let user_token: string = this.sessionService.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        headers.append('MIME-Version', '1.0');
        return this.http.post(this.config.getAllOrders, _body, {
            headers: headers
        })
    }

    updateOrderStatus(id, stat) {
        let user_token: string = this.sessionService.getToken();
        let _body = stat;
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);

        return this.http.put(this.config.updateOrderStatus(id), _body, {
            headers: headers
        })

    }

    getOrder(id) {
        let user_token: string = this.sessionService.getToken();
        let headers = new Headers();
        let body = {id};
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.get(this.config.getOrder(id),  {
            headers: headers
        })

    }

    getMembersForOrder(obj){
        let user_token: string = this.sessionService.getToken();
        let _body = obj;
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);

        return this.http.post(this.config.getMembersForOrder, _body, {
            headers: headers
        })

    }

    createOrder( stat) {
        let user_token: string = this.sessionService.getToken();
        let _body = stat;
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);

        return this.http.post(this.config.createOrder, _body, {
            headers: headers
        })

    }

    updateOrder(id, stat) {
        let user_token: string = this.sessionService.getToken();
        let _body = stat;
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);

        return this.http.post(this.config.updateOrder(id), _body, {
            headers: headers
        })

    }

    private handleError(error: any) {
        return Observable.throw(error.json());
    }

    getProductsList(obj) {
        let user_token: string = this.sessionService.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.post(this.config.getProductsList(), obj, {
            headers: headers
        })

    }

    getBenefactorList() {
        let user_token: string = this.sessionService.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.get(this.config.getBenefactorList, {
            headers: headers
        })

    }

    memberAddAddress(id, obj) {
        let user_token: string = this.sessionService.getToken();
        let _body = this.serialize(obj, '');
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post(this.config.memberAddAddress(id), _body, {
            headers: headers
        })

    }

    getAddressesList(id) {
        let user_token: string = this.sessionService.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.get(this.config.getAddressesList(id), {
            headers: headers
        })

    }

    getOrderPrice(data) {
        let user_token: string = this.sessionService.getToken();
        let _body = data;
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);

        return this.http.post(this.config.getOrderPrice, _body, {
            headers: headers
        })
    }

    exportOrders(userData) {
        let body = userData;
        let user_token: string = this.sessionService.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.post(this.config.exportOrders, body, {
            headers: headers,
            responseType: ResponseContentType.ArrayBuffer
        }).map(res => new Blob([res._body],{ type: 'application/vnd.ms-excel' }));
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/orders.service.ts